import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import Colors from '../../assets/Colors';

export default function NoProductFound() {
  return (
    <View style={styles.card}>
      <Text style={[styles.title, styles.centerText]}>Prodotto non trovato</Text>
      <View style={styles.centeredTextContainer}>
        <Text style={styles.centerText}>Siamo spiacenti,</Text>
        <Text style={styles.centerText}>non abbiamo quello che stai cercando</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    marginTop: 20,
    flex: 1,
    padding: 10,
    backgroundColor: Colors.redAlpha,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#ff2f68',
    borderRadius: 15,
    overflow: 'hidden',
    minHeight: 110,
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  centerText: {
    textAlign: 'center',
  },
  centeredTextContainer: {
    marginTop: 10,
  },
});
